export type PerfPulseMeta = {
  perfOrders: string
  perfBills: string
  perfItems: string
  perfReadyMs: string
  perfSnapshotMs: string
  perfLiveStartIso: string
  perfDeviceSubs: string
  perfPrintJobQueries: string
  perfPulseAt: string
}

const pulse = {
  orders: 0,
  bills: 0,
  items: 0,
  readyMs: 0,
  snapshotMs: 0,
  liveStartIso: '',
  deviceSubs: 0,
  printJobQueries: 0,
}

export function recordLiveCounts(counts: { orders?: number; bills?: number; items?: number }): void {
  if (counts.orders != null) pulse.orders = counts.orders
  if (counts.bills != null) pulse.bills = counts.bills
  if (counts.items != null) pulse.items = counts.items
}

export function recordReadyMs(ms: number): void {
  pulse.readyMs = Math.max(0, Math.round(ms))
}

export function recordSnapshotApplyMs(ms: number): void {
  pulse.snapshotMs = Math.max(0, Math.round(ms))
}

export function recordLiveStartIso(iso: string): void {
  pulse.liveStartIso = iso
}

export function recordDeviceSubDelta(delta: number): void {
  pulse.deviceSubs = Math.max(0, pulse.deviceSubs + delta)
}

export function recordPrintJobQueryDelta(delta: number): void {
  pulse.printJobQueries = Math.max(0, pulse.printJobQueries + delta)
}

export function getPerfPulseMeta(): PerfPulseMeta {
  return {
    perfOrders: String(pulse.orders),
    perfBills: String(pulse.bills),
    perfItems: String(pulse.items),
    perfReadyMs: String(pulse.readyMs),
    perfSnapshotMs: String(pulse.snapshotMs),
    perfLiveStartIso: pulse.liveStartIso,
    perfDeviceSubs: String(pulse.deviceSubs),
    perfPrintJobQueries: String(pulse.printJobQueries),
    perfPulseAt: new Date().toISOString(),
  }
}

export function formatPerfPulseLine(meta: Partial<Record<string, string>> | undefined): string {
  if (!meta) return 'Pulse: not reported yet'
  const orders = meta.perfOrders ?? '—'
  const bills = meta.perfBills ?? '—'
  const items = meta.perfItems ?? '—'
  const ready = meta.perfReadyMs ?? '—'
  const snap = meta.perfSnapshotMs ?? '—'
  const deviceSubs = meta.perfDeviceSubs ?? '—'
  const printQueries = meta.perfPrintJobQueries ?? '—'
  return `Live cache  ${orders} orders · ${bills} bills · ${items} items   Ready ${ready} ms   Snapshot ${snap} ms   Listeners ${deviceSubs} devices · ${printQueries} print queries`
}

export function formatOverlayPulseNote(overlay: {
  label: string | null
  orders: number
  bills: number
  items: number
}): string | null {
  if (!overlay.label) return null
  if (overlay.orders === 0 && overlay.bills === 0 && overlay.items === 0) return null
  const label =
    overlay.label.length === 10
      ? overlay.label.slice(8, 10) + '/' + overlay.label.slice(5, 7)
      : overlay.label
  return `Overlay ${overlay.orders} orders · ${overlay.bills} bills (${label})`
}
